export default "__VITE_ASSET__68OVcQtt__"